<template></template>
<script>
import FormCheckbox from "@/Components/FormCheckbox.vue";

export default {
    name: "StudentFlashcardFiltersFocusArea",
    components: { FormCheckbox },
    props: {
        focusArea: {},
    },
    data() {
        return {
            expanded: false,
            categories: this.focusArea.categories,
            selectedCategories: [],
        };
    },
    methods: {
        toggleCategoriesVisible() {
            this.expanded = !this.expanded;
        },
        toggleCategory(category) {
            category.selected = !category.selected;
            this.updateSelectedCategories();
        },
        selectAll() {
            this.categories.forEach(function (category) {
                category.selected = true;
            });

            this.$forceUpdate();
            this.updateSelectedCategories();
        },
        isSelected(category) {
            return _.includes(
                this.$page.props.flashcardFilters.categories,
                category.id
            );
        },
        updateSelectedCategories() {
            // let vm = this;
            //
            // vm.categories.forEach(function (category) {
            //     if (category.selected) {
            //         vm.$page.props.flashcardFilters1.categories.push(
            //             category.id
            //         );
            //     }
            // });
        },
    },
    mounted() {
        let vm = this;

        vm.categories.forEach(function (category) {
            category.selected = vm.isSelected(category);
        });
    },
};
</script>

<style>
.list-enter-active {
    transition: opacity 0.12s ease;
}

.list-leave-active {
    transition: opacity 0s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
}
</style>
